// extracted by mini-css-extract-plugin
export default {"events-nav":"EventsNavigation_events-nav__vya9W","nav-link":"EventsNavigation_nav-link__ZJqPu"};